/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getSurveyHealthAssessment = /* GraphQL */ `
  query GetSurveyHealthAssessment($id: ID!) {
    getSurveyHealthAssessment(id: $id) {
      id
      survey
      companyId
      companyName
      subjectId
      testId
      surveyTemplate
      consultant
      gender
      testDate
      bookingExperience
      onTime
      discussResults
      lifestyleChange
      professionalism
      experience
      recommend
      participate
      comment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSurveyHealthAssessments = /* GraphQL */ `
  query ListSurveyHealthAssessments(
    $filter: ModelSurveyHealthAssessmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSurveyHealthAssessments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        survey
        companyId
        companyName
        subjectId
        testId
        surveyTemplate
        consultant
        gender
        testDate
        bookingExperience
        onTime
        discussResults
        lifestyleChange
        professionalism
        experience
        recommend
        participate
        comment
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSurveyCompanyContact = /* GraphQL */ `
  query GetSurveyCompanyContact($id: ID!) {
    getSurveyCompanyContact(id: $id) {
      id
      companyId
      pulseId
      companyName
      participants
      service
      support
      quality
      professionalism
      impact
      valueformoney
      recommend
      mentalhealth
      fluvouchers
      onlineassessment
      promotions
      stressmanagement
      wellbeingdevelopment
      feedback
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSurveyCompanyContacts = /* GraphQL */ `
  query ListSurveyCompanyContacts(
    $filter: ModelSurveyCompanyContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSurveyCompanyContacts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        pulseId
        companyName
        participants
        service
        support
        quality
        professionalism
        impact
        valueformoney
        recommend
        mentalhealth
        fluvouchers
        onlineassessment
        promotions
        stressmanagement
        wellbeingdevelopment
        feedback
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSurveyCompany2022 = /* GraphQL */ `
  query GetSurveyCompany2022($id: ID!) {
    getSurveyCompany2022(id: $id) {
      id
      surveyId
      companyName
      event
      communication
      impact
      performance
      valueformoney
      feedback
      participants
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSurveyCompany2022s = /* GraphQL */ `
  query ListSurveyCompany2022s(
    $filter: ModelSurveyCompany2022FilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSurveyCompany2022s(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        surveyId
        companyName
        event
        communication
        impact
        performance
        valueformoney
        feedback
        participants
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSurveyWorkshop = /* GraphQL */ `
  query GetSurveyWorkshop($id: ID!) {
    getSurveyWorkshop(id: $id) {
      id
      company
      name
      date
      participants
      isDeleted
      surveyWorkshopFeedback {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSurveyWorkshops = /* GraphQL */ `
  query ListSurveyWorkshops(
    $filter: ModelSurveyWorkshopFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSurveyWorkshops(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        company
        name
        date
        participants
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSurveyDigitalVoucher = /* GraphQL */ `
  query GetSurveyDigitalVoucher($id: ID!) {
    getSurveyDigitalVoucher(id: $id) {
      id
      voucherCacheId
      company
      experience
      findpharmacy
      pharmacyExperience
      pharmacy
      communication
      previousVoucher
      recommend
      easierToUse
      comment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSurveyDigitalVouchers = /* GraphQL */ `
  query ListSurveyDigitalVouchers(
    $filter: ModelSurveyDigitalVoucherFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSurveyDigitalVouchers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        voucherCacheId
        company
        experience
        findpharmacy
        pharmacyExperience
        pharmacy
        communication
        previousVoucher
        recommend
        easierToUse
        comment
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSurveyWorkshopFeedback = /* GraphQL */ `
  query GetSurveyWorkshopFeedback($id: ID!) {
    getSurveyWorkshopFeedback(id: $id) {
      id
      trainer
      rateWorkshop
      workshopContent
      increaseUnderstanding
      usefulPrinciplesTechniques
      elementsChangeInclude
      recommend
      feedback
      surveyWorkshop {
        id
        company
        name
        date
        participants
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSurveyWorkshopFeedbacks = /* GraphQL */ `
  query ListSurveyWorkshopFeedbacks(
    $filter: ModelSurveyWorkshopFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSurveyWorkshopFeedbacks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        trainer
        rateWorkshop
        workshopContent
        increaseUnderstanding
        usefulPrinciplesTechniques
        elementsChangeInclude
        recommend
        feedback
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSurveyCoaching = /* GraphQL */ `
  query GetSurveyCoaching($id: ID!) {
    getSurveyCoaching(id: $id) {
      id
      company
      name
      date
      participants
      isDeleted
      surveyCoachingFeedback {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSurveyCoachings = /* GraphQL */ `
  query ListSurveyCoachings(
    $filter: ModelSurveyCoachingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSurveyCoachings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        company
        name
        date
        participants
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSurveyCoachingFeedback = /* GraphQL */ `
  query GetSurveyCoachingFeedback($id: ID!) {
    getSurveyCoachingFeedback(id: $id) {
      id
      rateCoaching
      benefitted
      connected
      actions
      expectations
      takeaway
      improve
      recommend
      feedback
      surveyCoaching {
        id
        company
        name
        date
        participants
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSurveyCoachingFeedbacks = /* GraphQL */ `
  query ListSurveyCoachingFeedbacks(
    $filter: ModelSurveyCoachingFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSurveyCoachingFeedbacks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        rateCoaching
        benefitted
        connected
        actions
        expectations
        takeaway
        improve
        recommend
        feedback
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const surveysBySurveyId = /* GraphQL */ `
  query SurveysBySurveyId(
    $surveyId: Int
    $sortDirection: ModelSortDirection
    $filter: ModelSurveyCompany2022FilterInput
    $limit: Int
    $nextToken: String
  ) {
    surveysBySurveyId(
      surveyId: $surveyId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        surveyId
        companyName
        event
        communication
        impact
        performance
        valueformoney
        feedback
        participants
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const surveysUpdated = /* GraphQL */ `
  query SurveysUpdated(
    $updatedAt: AWSDateTime
    $sortDirection: ModelSortDirection
    $filter: ModelSurveyCompany2022FilterInput
    $limit: Int
    $nextToken: String
  ) {
    surveysUpdated(
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        surveyId
        companyName
        event
        communication
        impact
        performance
        valueformoney
        feedback
        participants
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
